import { render, staticRenderFns } from "./ListActiveDetail3.vue?vue&type=template&id=3a9a6046&scoped=true&"
import script from "./ListActiveDetail3.vue?vue&type=script&lang=js&"
export * from "./ListActiveDetail3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9a6046",
  null
  
)

export default component.exports